module.exports = __webpack_public_path__ + "img/startConfigurationColliers@2x.81d884c.png";